/**
 * A mixin to track current Y-scroll position
 *
 * Is e.g. used to transform some widgets from normal to a 'sticky'
 * form (searchbar for example) or to move an opened menu when
 * scrolling.
 *
 * Main reactive attribute exposed is:
 *   - this.scrollTop
 */
export default {
  data() {
    return {
      scrollTop: 0,

      // FIXME: This is included for convenience because this mixin is
      //   mostly used to adapt the search box used on many pages on the
      //   same position, but from a strict viewpoint it should be moved
      //   to a separate mixin.
      fixedSearchThreshold: 51,
    };
  },
  mounted() {
    this.trackScrollTop();
  },
  methods: {
    /**
     * Capture current scroll Y position and store it as reactive prop.
     */
    trackScrollTop() {
      const vm = this;

      function onScroll() {
        // document.body.scrollTop will always be 0, so use
        // window.scrollY instead (actually use the alias below for
        // broader browser support).
        vm.scrollTop = window.pageYOffset;
      }
      // Desktop: onscroll() is fired during scrolling, all the time.
      document.body.onscroll = onScroll;
      // Mobile: onscroll() won't work here, we can use a touch event
      // but it only fires on finish, which is okay here.
      document.body.addEventListener('touchmove', onScroll);
    },
    scrollToTop() {
      window.scroll(0, 0);
    },
    scrollToBottom() {
      window.scroll(0, document.body.scrollHeight);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/trackScrollTop.js